import { render, staticRenderFns } from "./ResizeButton.vue?vue&type=template&id=e8effdf4&"
import script from "./ResizeButton.vue?vue&type=script&lang=js&"
export * from "./ResizeButton.vue?vue&type=script&lang=js&"
import style0 from "./ResizeButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports